import { render, staticRenderFns } from "./payMiddlePage.vue?vue&type=template&id=69956620&scoped=true&"
import script from "./payMiddlePage.ts?vue&type=script&lang=js&"
export * from "./payMiddlePage.ts?vue&type=script&lang=js&"
import style0 from "./payMiddlePage.less?vue&type=style&index=0&id=69956620&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69956620",
  null
  
)

export default component.exports